import React from 'react'

import { DeliveryAddressRule, PickupAddressRule } from '../../utils/types'
import AddressRule from './index'


interface Props {
  value: PickupAddressRule
  onChange: (val: Props['value']) => void
}


const PickupAddressRule = (props:Props) => (
  <AddressRule
    value={transPickup2Delivery(props.value)}
    onChange={(value) => props.onChange(transDelivery2Pickup(value))}
  />
)

/** 外卖格式转换为自取格式 */
export function transDelivery2Pickup (data: DeliveryAddressRule): PickupAddressRule {
  return {
    checkPickupAddress: data?.checkDeliveryAddress,
    pickupAddressList: data?.deliveryAddressList,
  }
}

/** 自取格式转换为外卖格式 */
export function transPickup2Delivery (data: PickupAddressRule): DeliveryAddressRule  {
  return {
    checkDeliveryAddress: data?.checkPickupAddress,
    deliveryAddressList: data?.pickupAddressList,
  }
}

export default PickupAddressRule